// The redesign's confirm (Figma "Web dialog": Default / Destructive, with the
// optional "Type to confirm"). It takes the same props as ui/confirm.jsx's
// ConfirmView, so ConfirmProvider moves onto it with one line when the shell
// is rebuilt; useConfirm() stays the way to ask.
import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Button } from './Button';

export function ConfirmDialogView({ open, options, typed = '', onTyped = () => {}, onAnswer }) {
  const o = options || {};
  const needs = o.requireText ? typed.trim().toLowerCase() === String(o.requireText).trim().toLowerCase() : true;
  return (
    <DialogPrimitive.Root open={open} onOpenChange={(next) => { if (!next) onAnswer(false); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[10020] bg-black/60" />
        <DialogPrimitive.Content role="alertdialog"
          className="fixed left-1/2 top-1/2 z-[10021] flex w-[calc(100%-2rem)] max-w-[480px] -translate-x-1/2 -translate-y-1/2 flex-col gap-3.5 rounded-[20px] border border-border-default bg-bg-panel p-7 font-body shadow-[0_24px_64px_rgba(0,0,0,0.45)] focus:outline-none">
          <DialogPrimitive.Title className="m-0 type-title-page text-text-primary">{o.title}</DialogPrimitive.Title>
          {o.description ? (
            <DialogPrimitive.Description className="m-0 type-body text-text-secondary">{o.description}</DialogPrimitive.Description>
          ) : (
            <DialogPrimitive.Description className="sr-only">{o.title}</DialogPrimitive.Description>
          )}
          <form className="flex flex-col gap-3.5" onSubmit={(e) => { e.preventDefault(); if (needs) onAnswer(true); }}>
            {o.requireText && (
              <label className="flex flex-col gap-1.5 type-caption text-text-tertiary">
                {o.requireLabel || <>Type {o.requireText} to confirm</>}
                <input autoFocus value={typed} onChange={(e) => onTyped(e.target.value)} autoComplete="off" spellCheck={false}
                  className="h-[46px] rounded-[10px] border border-border-default bg-bg-canvas px-3 type-body text-text-primary focus:border-accent-default focus:outline-none" />
              </label>
            )}
            <div className="flex flex-col-reverse gap-2 pt-2 sm:flex-row sm:justify-end">
              {!o.alert && (
                <Button kind="secondary" size="small" onClick={() => onAnswer(false)}>{o.cancelText || 'Cancel'}</Button>
              )}
              <Button type="submit" size="small" kind={o.destructive ? 'danger' : 'primary'} disabled={!needs}
                autoFocus={!o.requireText}>
                {o.confirmText || 'OK'}
              </Button>
            </div>
          </form>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
